
Number.prototype.format = function (fix) {
    if (fix === undefined) fix = 2;
    var num = this.toFixed(fix);
    var z = num.split('.');
    var format = [], f = z[0].split(''), l = f.length;
    for (var i = 0; i < l; i++) {
        if (i > 0 && i % 3 == 0) {
            format.unshift(',');
        }
        format.unshift(f[l - i - 1]);
    }
    return format.join('') + (z.length == 2 ? '.' + z[1] : '');
};
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/(^\s+|\s+$)/g, '');
    }
}
String.prototype.compile = function (data, list) {

    if (list) {
        var temps = [];
        for (var i in data) {
            temps.push(this.compile(data[i]));
        }
        return temps.join("\n");
    } else {
        return this.replace(/\{if\s+([^\}]+)\}([\W\w]*?){\/if}/g, function (all, condition, cont) {
            var operation;
            var conts = cont.split('{else}');
            if (operation = condition.match(/\s+(=+|<|>)\s+/)) {
                operation = operation[0];
                var part = condition.split(operation);
                if (part[0].indexOf('@') === 0) {
                    part[0] = data[part[0].replace('@', '')];
                }
                if (part[1].indexOf('@') === 0) {
                    part[1] = data[part[1].replace('@', '')];
                }
                operation = operation.trim();
                var result = false;
                switch (operation) {
                    case '==':
                        result = part[0] == part[1];
                        break;
                    case '===':
                        result = part[0] === part[1];
                        break;
                    case '>':
                        result = part[0] > part[1];
                        break;
                    case '<':
                        result = part[0] < part[1];
                        break;
                }
                if (result) {
                    return cont;
                } else if (conts[1]) {
                    return conts[1];
                }
            } else {
                if (data[condition.replace('@', '')]) return conts[0];
                else if (conts[1]) return conts[1];
            }
            return '';
        }).replace(/\{@([\w\d\.]+)(?:\|([\w\d]+)(?:\s*=\s*([^\}]+))?)?\}/g, function (all, m1, func, args) {

            if (m1.indexOf('.') > 0) {
                var keys = m1.split('.'), val = data;
                for (var i = 0; i < keys.length; i++) {
                    if (val[keys[i]] !== undefined && val[keys[i]] !== null) {
                        val = val[keys[i]];
                    } else {
                        val = '';
                        break;
                    }
                }
                return callfunc(val, func, args);
            } else {
                return callfunc(data[m1], func, args, data);
            }
        });
    }
};

function tostring(obj) {
    if (obj && obj.toString) {
        return obj.toString();
    }
    return '';
}

function callfunc(val, func, args, thisobj) {
    if (!args) {
        args = [val];
    } else {
        if (typeof args === 'string') args = args.split(',');
        var argidx = args.indexOf('###');
        if (argidx >= 0) {
            args[argidx] = val;
        } else {
            args = [val].concat(args);
        }
    }

    return window[func] ? window[func].apply(thisobj, args) : ((val === undefined || val === null) ? '' : val);
}


function html_encode(html) {
    if (!html) return html;
    var temp = document.createElement("div");
    (temp.textContent != undefined) ? (temp.textContent = html) : (temp.innerText = html);
    var output = temp.innerHTML;
    temp = null;
    return output;
}
function html_decode(text) {
    if (!text) return text;
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
}

function pad_zero(n, c) {
    if ((n = n + "").length < c) {
        return new Array(++c - n.length).join("0") + n;
    } else {
        return n;
    }
}

function timestamp_date(timestamp, fmt) {
    if (!timestamp) return '';
    var jsdate = new Date(timestamp * 1000);
    if (!fmt) fmt = 'Y-m-d H:i:s';

    var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var txt_ordin = {
        1: "st",
        2: "nd",
        3: "rd",
        21: "st",
        22: "nd",
        23: "rd",
        31: "st"
    };
    var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var f = {
        // Day 
        d: function () {
            return pad_zero(f.j(), 2)
        },
        D: function () {
            return f.l().substr(0, 3)
        },
        j: function () {
            return jsdate.getDate()
        },
        l: function () {
            return txt_weekdays[f.w()]
        },
        N: function () {
            return f.w() + 1
        },
        S: function () {
            return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
        },
        w: function () {
            return jsdate.getDay()
        },
        z: function () {
            return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0
        },

        // Week 
        W: function () {
            var a = f.z(),
                b = 364 + f.L() - a;
            var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
            if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
                return 1;
            } else {
                if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
                    nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
                    return timestamp_date(Math.round(nd2.getTime() / 1000), "W");
                } else {
                    return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
                }
            }
        },

        // Month 
        F: function () {
            return txt_months[f.n()]
        },
        m: function () {
            return pad_zero(f.n(), 2)
        },
        M: function () {
            return f.F().substr(0, 3)
        },
        n: function () {
            return jsdate.getMonth() + 1
        },
        t: function () {
            var n;
            if ((n = jsdate.getMonth() + 1) == 2) {
                return 28 + f.L();
            } else {
                if (n & 1 && n < 8 || !(n & 1) && n > 7) {
                    return 31;
                } else {
                    return 30;
                }
            }
        },

        // Year 
        L: function () {
            var y = f.Y();
            return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
        },
        //o not supported yet 
        Y: function () {
            return jsdate.getFullYear()
        },
        y: function () {
            return (jsdate.getFullYear() + "").slice(2)
        },

        // Time 
        a: function () {
            return jsdate.getHours() > 11 ? "pm" : "am"
        },
        A: function () {
            return f.a().toUpperCase()
        },
        B: function () {
            // peter paul koch: 
            var off = (jsdate.getTimezoneOffset() + 60) * 60;
            var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
            var beat = Math.floor(theSeconds / 86.4);
            if (beat > 1000) beat -= 1000;
            if (beat < 0) beat += 1000;
            if ((String(beat)).length == 1) beat = "00" + beat;
            if ((String(beat)).length == 2) beat = "0" + beat;
            return beat;
        },
        g: function () {
            return jsdate.getHours() % 12 || 12
        },
        G: function () {
            return jsdate.getHours()
        },
        h: function () {
            return pad_zero(f.g(), 2)
        },
        H: function () {
            return pad_zero(jsdate.getHours(), 2)
        },
        i: function () {
            return pad_zero(jsdate.getMinutes(), 2)
        },
        s: function () {
            return pad_zero(jsdate.getSeconds(), 2)
        },
        //u not supported yet 

        // Timezone 
        //e not supported yet 
        //I not supported yet 
        O: function () {
            var t = pad_zero(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
            if (jsdate.getTimezoneOffset() > 0) t = "-" + t;
            else t = "+" + t;
            return t;
        },
        P: function () {
            var O = f.O();
            return (O.substr(0, 3) + ":" + O.substr(3, 2))
        },
        //T not supported yet 
        //Z not supported yet 

        // Full Date/Time 
        c: function () {
            return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()
        },
        //r not supported yet 
        U: function () {
            return Math.round(jsdate.getTime() / 1000)
        }
    };

    return fmt.replace(/[\\]?([a-zA-Z])/g, function (t, s) {
        var ret = '';
        if (t != s) {
            // escaped 
            ret = s;
        } else if (f[s]) {
            // a date function exists 
            ret = f[s]();
        } else {
            // nothing special 
            ret = s;
        }
        return ret;
    });
}

function iif(v, m1, m2) {
    if (v === '0') v = 0;
    return v ? m1 : m2;
}

window['default'] = function (v, d) {
    return v ? v : d;
};